import React, { useState } from 'react';
import { Plus, Search, X } from 'lucide-react';
import { SmallText } from '../../../components/brand/BrandTypography';
import { SecondaryButton } from '../../../components/brand/BrandButton';
import ToolCard from '../components/ToolCard';
import { TOOL_TYPE_CONFIG } from '../constants';

const ToolsTab = ({ tools, filterType, setFilterType, onEdit, onDelete, onPreview, onCreateNew }) => {
    const [searchQuery, setSearchQuery] = useState('');
    
    const filteredTools = tools.filter(t => {
        const matchesType = filterType === 'all' || t.type === filterType;
        const matchesSearch = searchQuery === '' || 
            t.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            t.instruction?.toLowerCase().includes(searchQuery.toLowerCase());
        return matchesType && matchesSearch;
    });

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex items-center gap-3 flex-wrap">
                    {/* Search Input */}
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#7D8E95]" />
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search tools..."
                            className="pl-9 pr-8 py-1.5 rounded-lg border border-[#FFBB98] bg-white text-sm w-48 focus:outline-none focus:ring-2 focus:ring-[#7D8E95] focus:border-transparent"
                        />
                        {searchQuery && (
                            <button
                                onClick={() => setSearchQuery('')}
                                className="absolute right-2 top-1/2 -translate-y-1/2 p-0.5 hover:bg-[#FFBB98] rounded"
                            >
                                <X className="w-3.5 h-3.5 text-[#7D8E95]" />
                            </button>
                        )}
                    </div>
                    
                    {/* Type Filter */}
                    <div className="flex items-center gap-2">
                        <SmallText className="text-[#7D8E95]">Type:</SmallText>
                        <select
                            value={filterType}
                            onChange={(e) => setFilterType(e.target.value)}
                            className="px-3 py-1.5 rounded-lg border border-[#FFBB98] bg-white text-sm"
                        >
                            <option value="all">All Types</option>
                            {Object.entries(TOOL_TYPE_CONFIG).map(([key, config]) => (
                                <option key={key} value={key}>{config.label}</option>
                            ))}
                        </select>
                    </div>
                    
                    {/* Results Count */}
                    <SmallText className="text-[#7D8E95]">
                        {filteredTools.length} tool{filteredTools.length !== 1 ? 's' : ''}
                        {searchQuery && ` matching "${searchQuery}"`}
                    </SmallText>
                </div>
                <SecondaryButton onClick={onCreateNew}>
                    <Plus className="w-4 h-4 mr-2" />
                    New Tool
                </SecondaryButton>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {filteredTools.map(tool => (
                    <ToolCard 
                        key={tool.tool_id} 
                        tool={tool} 
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onPreview={onPreview}
                    />
                ))}
            </div>
        </div>
    );
};

export default ToolsTab;
